import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import mutations from '../../../../graphql/mutations';
import PBNUploader from './PBNUploader.js';

export default function PbnManager ({ parentId, parentType, onProcessingComplete }) {
  const [isLoading, setIsLoading] = useState(false);
  const [filename, setFilename] = useState(null);

  const [processPbn] = useMutation(mutations.ProcessPbn);

  // B3.3b — pbnProcessor re-homed from the S3-event Lambda to a synchronous GraphQL mutation. Fire it
  // once the R2 PUT completes and read the final status directly; the old pbnByFilename status-poll
  // (its 30 × 1s retry loop) is gone because processing now happens inline in the mutation on the Worker.
  const processUploadedPbn = async () => {
    try {
      const { data } = await processPbn({ variables: { filename, parentType, parentId } });
      const pbn = data && data.processPbn;
      if (pbn && pbn.status === 'complete') {
        onProcessingComplete();
      } else {
        onProcessingComplete(`Converting PBN failed: ${pbn ? pbn.error : 'unknown error'}`);
      }
    } catch (err) {
      onProcessingComplete(`Converting PBN failed: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUploadError = (message) => {
    onProcessingComplete(message);
  };

  const handleUploadFileNameGenerated = async (filename) => {
    setIsLoading(true);
    setFilename(filename);
  };

  return (
    <div>
      <PBNUploader
        onUploadComplete={processUploadedPbn}
        onUploadFilenameGenerated={handleUploadFileNameGenerated}
        onUploadError={handleUploadError}
        parentId={parentId}
        parentType={parentType}
        isLoading={isLoading}
      />
    </div>
  );
}

// PbnManager.propTypes = {
//   setId: PropTypes.number.isRequired,
//   onProcessingComplete: PropTypes.func.isRequired
// };
